export default "__VITE_ASSET__FQ4g4s5e__"